var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalContext } from "@/contexts";
import { UserTrackingFlow } from "@/types/ApplyFlowParameters";
import { ImpressionPixelType } from "@/types/ImpressionPixelProperties";
import { Grid, GridItem, useRecipe } from "@chakra-ui/react";
import { useContext } from "react";
import { useDetectMobileViewPort } from "@/components/cortex/hooks/useDetectMobileViewPort";
import { ImpressionPixel } from "../UserTracking";
import { SearchResultsCompanyLogo } from "./SearchResultsCompanyLogo";
import { SearchResultsListItemDetails } from "./SearchResultsListItemDetails";
import { SearchResultsListItemMobile } from "./SearchResultsListItemMobile";
export var SearchResultsListItem = function (_a) {
    var job = _a.job;
    var recipe = useRecipe({ key: "SearchResultsListItem" });
    var styles = recipe();
    var applyFlowParameters = useContext(GlobalContext).applyFlowParameters;
    var pixels = (applyFlowParameters === null || applyFlowParameters === void 0 ? void 0 : applyFlowParameters.userTrackingFlow) === UserTrackingFlow.CAREER_SITES ? (_jsx(ImpressionPixel, { type: ImpressionPixelType.OFFCAP_RENDER, jobKey: job.jobKey })) : (_jsxs(_Fragment, { children: [_jsx(ImpressionPixel, { type: ImpressionPixelType.TMN_VIEW, jobKey: job.jobKey, impressionUrl: job.impressionViewUrl }), _jsx(ImpressionPixel, { type: ImpressionPixelType.TMN_RENDER, jobKey: job.jobKey, impressionUrl: job.impressionRenderUrl })] }));
    var isMobile = useDetectMobileViewPort().isMobile;
    if (isMobile) {
        return (_jsx(SearchResultsListItemMobile, { job: job, pixels: pixels, styles: styles }));
    }
    return (_jsxs(Grid, __assign({ templateColumns: "repeat(5, 1fr)", css: styles }, { children: [_jsx(GridItem, __assign({ colSpan: 1 }, { children: _jsx(SearchResultsCompanyLogo, { job: job }) })), _jsx(GridItem, __assign({ colSpan: 4 }, { children: _jsx(SearchResultsListItemDetails, { job: job }) })), _jsx(GridItem, __assign({ colSpan: 1 }, { children: pixels }))] })));
};
